var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 122,
    viewBox: "0 0 337 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_1755",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 337,
    height: 122
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H327C332.523 0 337 4.47715 337 10V122H0V10Z",
    fill: "url(#paint0_linear_25_1755)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_1755)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 0.806234L0.707107 5.12728L4.49687 9.44832L8.28664 5.12728L4.49687 0.806234ZM0 5.12728L4.49687 10.2546L8.99375 5.12728L4.49687 -2.34751e-08L0 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 11.0642L0.707107 15.3853L4.49687 19.7063L8.28664 15.3853L4.49687 11.0642ZM0 15.3853L4.49687 20.5126L8.99375 15.3853L4.49687 10.258L0 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 21.3325L0.707107 25.6536L4.49687 29.9746L8.28664 25.6536L4.49687 21.3325ZM0 25.6536L4.49687 30.7808L8.99375 25.6536L4.49687 20.5263L0 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 0.806234L9.70387 5.12728L13.4936 9.44832L17.2834 5.12728L13.4936 0.806234ZM8.99677 5.12728L13.4936 10.2546L17.9905 5.12728L13.4936 -2.34751e-08L8.99677 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 11.0642L9.70387 15.3853L13.4936 19.7063L17.2834 15.3853L13.4936 11.0642ZM8.99677 15.3853L13.4936 20.5126L17.9905 15.3853L13.4936 10.258L8.99677 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 21.3325L9.70387 25.6536L13.4936 29.9746L17.2834 25.6536L13.4936 21.3325ZM8.99677 25.6536L13.4936 30.7808L17.9905 25.6536L13.4936 20.5263L8.99677 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 0.806234L18.7097 5.12728L22.4994 9.44832L26.2892 5.12728L22.4994 0.806234ZM18.0026 5.12728L22.4994 10.2546L26.9963 5.12728L22.4994 -2.34751e-08L18.0026 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 11.0642L18.7097 15.3853L22.4994 19.7063L26.2892 15.3853L22.4994 11.0642ZM18.0026 15.3853L22.4994 20.5126L26.9963 15.3853L22.4994 10.258L18.0026 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 21.3325L18.7097 25.6536L22.4994 29.9746L26.2892 25.6536L22.4994 21.3325ZM18.0026 25.6536L22.4994 30.7808L26.9963 25.6536L22.4994 20.5263L18.0026 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 0.806234L135.707 5.12728L139.497 9.44832L143.287 5.12728L139.497 0.806234ZM135 5.12728L139.497 10.2546L143.994 5.12728L139.497 -2.34751e-08L135 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 11.0642L135.707 15.3853L139.497 19.7063L143.287 15.3853L139.497 11.0642ZM135 15.3853L139.497 20.5126L143.994 15.3853L139.497 10.258L135 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 21.3325L135.707 25.6536L139.497 29.9746L143.287 25.6536L139.497 21.3325ZM135 25.6536L139.497 30.7808L143.994 25.6536L139.497 20.5263L135 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 0.806234L144.704 5.12728L148.494 9.44832L152.283 5.12728L148.494 0.806234ZM143.997 5.12728L148.494 10.2546L152.991 5.12728L148.494 -2.34751e-08L143.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 11.0642L144.704 15.3853L148.494 19.7063L152.283 15.3853L148.494 11.0642ZM143.997 15.3853L148.494 20.5126L152.991 15.3853L148.494 10.258L143.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 21.3325L144.704 25.6536L148.494 29.9746L152.283 25.6536L148.494 21.3325ZM143.997 25.6536L148.494 30.7808L152.991 25.6536L148.494 20.5263L143.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 0.806234L153.71 5.12728L157.499 9.44832L161.289 5.12728L157.499 0.806234ZM153.003 5.12728L157.499 10.2546L161.996 5.12728L157.499 -2.34751e-08L153.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 11.0642L153.71 15.3853L157.499 19.7063L161.289 15.3853L157.499 11.0642ZM153.003 15.3853L157.499 20.5126L161.996 15.3853L157.499 10.258L153.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 21.3325L153.71 25.6536L157.499 29.9746L161.289 25.6536L157.499 21.3325ZM153.003 25.6536L157.499 30.7808L161.996 25.6536L157.499 20.5263L153.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 31.5913L0.707107 35.9123L4.49687 40.2334L8.28664 35.9123L4.49687 31.5913ZM0 35.9123L4.49687 41.0396L8.99375 35.9123L4.49687 30.785L0 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 41.8493L0.707107 46.1703L4.49687 50.4914L8.28664 46.1703L4.49687 41.8493ZM0 46.1703L4.49687 51.2976L8.99375 46.1703L4.49687 41.043L0 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 52.1176L0.707107 56.4386L4.49687 60.7596L8.28664 56.4386L4.49687 52.1176ZM0 56.4386L4.49687 61.5659L8.99375 56.4386L4.49687 51.3113L0 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 31.5913L9.70387 35.9123L13.4936 40.2334L17.2834 35.9123L13.4936 31.5913ZM8.99677 35.9123L13.4936 41.0396L17.9905 35.9123L13.4936 30.785L8.99677 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 41.8493L9.70387 46.1703L13.4936 50.4914L17.2834 46.1703L13.4936 41.8493ZM8.99677 46.1703L13.4936 51.2976L17.9905 46.1703L13.4936 41.043L8.99677 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 52.1176L9.70387 56.4386L13.4936 60.7596L17.2834 56.4386L13.4936 52.1176ZM8.99677 56.4386L13.4936 61.5659L17.9905 56.4386L13.4936 51.3113L8.99677 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 31.5913L18.7097 35.9123L22.4994 40.2334L26.2892 35.9123L22.4994 31.5913ZM18.0026 35.9123L22.4994 41.0396L26.9963 35.9123L22.4994 30.785L18.0026 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 41.8493L18.7097 46.1703L22.4994 50.4914L26.2892 46.1703L22.4994 41.8493ZM18.0026 46.1703L22.4994 51.2976L26.9963 46.1703L22.4994 41.043L18.0026 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 52.1176L18.7097 56.4386L22.4994 60.7596L26.2892 56.4386L22.4994 52.1176ZM18.0026 56.4386L22.4994 61.5659L26.9963 56.4386L22.4994 51.3113L18.0026 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 31.5913L135.707 35.9123L139.497 40.2334L143.287 35.9123L139.497 31.5913ZM135 35.9123L139.497 41.0396L143.994 35.9123L139.497 30.785L135 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 41.8493L135.707 46.1703L139.497 50.4914L143.287 46.1703L139.497 41.8493ZM135 46.1703L139.497 51.2976L143.994 46.1703L139.497 41.043L135 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 52.1176L135.707 56.4386L139.497 60.7596L143.287 56.4386L139.497 52.1176ZM135 56.4386L139.497 61.5659L143.994 56.4386L139.497 51.3113L135 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 31.5913L144.704 35.9123L148.494 40.2334L152.283 35.9123L148.494 31.5913ZM143.997 35.9123L148.494 41.0396L152.991 35.9123L148.494 30.785L143.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 41.8493L144.704 46.1703L148.494 50.4914L152.283 46.1703L148.494 41.8493ZM143.997 46.1703L148.494 51.2976L152.991 46.1703L148.494 41.043L143.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 52.1176L144.704 56.4386L148.494 60.7596L152.283 56.4386L148.494 52.1176ZM143.997 56.4386L148.494 61.5659L152.991 56.4386L148.494 51.3113L143.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 31.5913L153.71 35.9123L157.499 40.2334L161.289 35.9123L157.499 31.5913ZM153.003 35.9123L157.499 41.0396L161.996 35.9123L157.499 30.785L153.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 41.8493L153.71 46.1703L157.499 50.4914L161.289 46.1703L157.499 41.8493ZM153.003 46.1703L157.499 51.2976L161.996 46.1703L157.499 41.043L153.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 52.1176L153.71 56.4386L157.499 60.7596L161.289 56.4386L157.499 52.1176ZM153.003 56.4386L157.499 61.5659L161.996 56.4386L157.499 51.3113L153.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 61.2361L0.707107 65.5572L4.49687 69.8782L8.28664 65.5572L4.49687 61.2361ZM0 65.5572L4.49687 70.6845L8.99375 65.5572L4.49687 60.4299L0 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 71.4941L0.707107 75.8152L4.49687 80.1362L8.28664 75.8152L4.49687 71.4941ZM0 75.8152L4.49687 80.9425L8.99375 75.8152L4.49687 70.6879L0 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 81.7624L0.707107 86.0835L4.49687 90.4045L8.28664 86.0835L4.49687 81.7624ZM0 86.0835L4.49687 91.2107L8.99375 86.0835L4.49687 80.9562L0 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 61.2361L9.70387 65.5572L13.4936 69.8782L17.2834 65.5572L13.4936 61.2361ZM8.99677 65.5572L13.4936 70.6845L17.9905 65.5572L13.4936 60.4299L8.99677 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 71.4941L9.70387 75.8152L13.4936 80.1362L17.2834 75.8152L13.4936 71.4941ZM8.99677 75.8152L13.4936 80.9425L17.9905 75.8152L13.4936 70.6879L8.99677 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 81.7624L9.70387 86.0835L13.4936 90.4045L17.2834 86.0835L13.4936 81.7624ZM8.99677 86.0835L13.4936 91.2107L17.9905 86.0835L13.4936 80.9562L8.99677 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 61.2361L18.7097 65.5572L22.4994 69.8782L26.2892 65.5572L22.4994 61.2361ZM18.0026 65.5572L22.4994 70.6845L26.9963 65.5572L22.4994 60.4299L18.0026 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 71.4941L18.7097 75.8152L22.4994 80.1362L26.2892 75.8152L22.4994 71.4941ZM18.0026 75.8152L22.4994 80.9425L26.9963 75.8152L22.4994 70.6879L18.0026 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 81.7624L18.7097 86.0835L22.4994 90.4045L26.2892 86.0835L22.4994 81.7624ZM18.0026 86.0835L22.4994 91.2107L26.9963 86.0835L22.4994 80.9562L18.0026 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 61.2361L135.707 65.5572L139.497 69.8782L143.287 65.5572L139.497 61.2361ZM135 65.5572L139.497 70.6845L143.994 65.5572L139.497 60.4299L135 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 71.4941L135.707 75.8152L139.497 80.1362L143.287 75.8152L139.497 71.4941ZM135 75.8152L139.497 80.9425L143.994 75.8152L139.497 70.6879L135 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 81.7624L135.707 86.0835L139.497 90.4045L143.287 86.0835L139.497 81.7624ZM135 86.0835L139.497 91.2107L143.994 86.0835L139.497 80.9562L135 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 61.2361L144.704 65.5572L148.494 69.8782L152.283 65.5572L148.494 61.2361ZM143.997 65.5572L148.494 70.6845L152.991 65.5572L148.494 60.4299L143.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 71.4941L144.704 75.8152L148.494 80.1362L152.283 75.8152L148.494 71.4941ZM143.997 75.8152L148.494 80.9425L152.991 75.8152L148.494 70.6879L143.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 81.7624L144.704 86.0835L148.494 90.4045L152.283 86.0835L148.494 81.7624ZM143.997 86.0835L148.494 91.2107L152.991 86.0835L148.494 80.9562L143.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 61.2361L153.71 65.5572L157.499 69.8782L161.289 65.5572L157.499 61.2361ZM153.003 65.5572L157.499 70.6845L161.996 65.5572L157.499 60.4299L153.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 71.4941L153.71 75.8152L157.499 80.1362L161.289 75.8152L157.499 71.4941ZM153.003 75.8152L157.499 80.9425L161.996 75.8152L157.499 70.6879L153.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 81.7624L153.71 86.0835L157.499 90.4045L161.289 86.0835L157.499 81.7624ZM153.003 86.0835L157.499 91.2107L161.996 86.0835L157.499 80.9562L153.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 92.0212L0.707107 96.3422L4.49687 100.663L8.28664 96.3422L4.49687 92.0212ZM0 96.3422L4.49687 101.47L8.99375 96.3422L4.49687 91.2149L0 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 102.279L0.707107 106.6L4.49687 110.921L8.28664 106.6L4.49687 102.279ZM0 106.6L4.49687 111.727L8.99375 106.6L4.49687 101.473L0 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49687 112.547L0.707107 116.869L4.49687 121.19L8.28664 116.869L4.49687 112.547ZM0 116.869L4.49687 121.996L8.99375 116.869L4.49687 111.741L0 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 92.0212L9.70387 96.3422L13.4936 100.663L17.2834 96.3422L13.4936 92.0212ZM8.99677 96.3422L13.4936 101.47L17.9905 96.3422L13.4936 91.2149L8.99677 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 102.279L9.70387 106.6L13.4936 110.921L17.2834 106.6L13.4936 102.279ZM8.99677 106.6L13.4936 111.727L17.9905 106.6L13.4936 101.473L8.99677 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4936 112.547L9.70387 116.869L13.4936 121.19L17.2834 116.869L13.4936 112.547ZM8.99677 116.869L13.4936 121.996L17.9905 116.869L13.4936 111.741L8.99677 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 92.0212L18.7097 96.3422L22.4994 100.663L26.2892 96.3422L22.4994 92.0212ZM18.0026 96.3422L22.4994 101.47L26.9963 96.3422L22.4994 91.2149L18.0026 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 102.279L18.7097 106.6L22.4994 110.921L26.2892 106.6L22.4994 102.279ZM18.0026 106.6L22.4994 111.727L26.9963 106.6L22.4994 101.473L18.0026 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4994 112.547L18.7097 116.869L22.4994 121.19L26.2892 116.869L22.4994 112.547ZM18.0026 116.869L22.4994 121.996L26.9963 116.869L22.4994 111.741L18.0026 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 92.0212L135.707 96.3422L139.497 100.663L143.287 96.3422L139.497 92.0212ZM135 96.3422L139.497 101.47L143.994 96.3422L139.497 91.2149L135 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 102.279L135.707 106.6L139.497 110.921L143.287 106.6L139.497 102.279ZM135 106.6L139.497 111.727L143.994 106.6L139.497 101.473L135 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.497 112.547L135.707 116.869L139.497 121.19L143.287 116.869L139.497 112.547ZM135 116.869L139.497 121.996L143.994 116.869L139.497 111.741L135 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 92.0212L144.704 96.3422L148.494 100.663L152.283 96.3422L148.494 92.0212ZM143.997 96.3422L148.494 101.47L152.991 96.3422L148.494 91.2149L143.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 102.279L144.704 106.6L148.494 110.921L152.283 106.6L148.494 102.279ZM143.997 106.6L148.494 111.727L152.991 106.6L148.494 101.473L143.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.494 112.547L144.704 116.869L148.494 121.19L152.283 116.869L148.494 112.547ZM143.997 116.869L148.494 121.996L152.991 116.869L148.494 111.741L143.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 92.0212L153.71 96.3422L157.499 100.663L161.289 96.3422L157.499 92.0212ZM153.003 96.3422L157.499 101.47L161.996 96.3422L157.499 91.2149L153.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 102.279L153.71 106.6L157.499 110.921L161.289 106.6L157.499 102.279ZM153.003 106.6L157.499 111.727L161.996 106.6L157.499 101.473L153.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.499 112.547L153.71 116.869L157.499 121.19L161.289 116.869L157.499 112.547ZM153.003 116.869L157.499 121.996L161.996 116.869L157.499 111.741L153.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 0.806234L27.7071 5.12728L31.4969 9.44832L35.2866 5.12728L31.4969 0.806234ZM27 5.12728L31.4969 10.2546L35.9937 5.12728L31.4969 -2.34751e-08L27 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 11.0642L27.7071 15.3853L31.4969 19.7063L35.2866 15.3853L31.4969 11.0642ZM27 15.3853L31.4969 20.5126L35.9937 15.3853L31.4969 10.258L27 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 21.3325L27.7071 25.6536L31.4969 29.9746L35.2866 25.6536L31.4969 21.3325ZM27 25.6536L31.4969 30.7808L35.9937 25.6536L31.4969 20.5263L27 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 0.806234L36.7039 5.12728L40.4936 9.44832L44.2834 5.12728L40.4936 0.806234ZM35.9968 5.12728L40.4936 10.2546L44.9905 5.12728L40.4936 -2.34751e-08L35.9968 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 11.0642L36.7039 15.3853L40.4936 19.7063L44.2834 15.3853L40.4936 11.0642ZM35.9968 15.3853L40.4936 20.5126L44.9905 15.3853L40.4936 10.258L35.9968 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 21.3325L36.7039 25.6536L40.4936 29.9746L44.2834 25.6536L40.4936 21.3325ZM35.9968 25.6536L40.4936 30.7808L44.9905 25.6536L40.4936 20.5263L35.9968 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 0.806234L45.7097 5.12728L49.4994 9.44832L53.2892 5.12728L49.4994 0.806234ZM45.0026 5.12728L49.4994 10.2546L53.9963 5.12728L49.4994 -2.34751e-08L45.0026 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 11.0642L45.7097 15.3853L49.4994 19.7063L53.2892 15.3853L49.4994 11.0642ZM45.0026 15.3853L49.4994 20.5126L53.9963 15.3853L49.4994 10.258L45.0026 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 21.3325L45.7097 25.6536L49.4994 29.9746L53.2892 25.6536L49.4994 21.3325ZM45.0026 25.6536L49.4994 30.7808L53.9963 25.6536L49.4994 20.5263L45.0026 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 0.806234L162.707 5.12728L166.497 9.44832L170.287 5.12728L166.497 0.806234ZM162 5.12728L166.497 10.2546L170.994 5.12728L166.497 -2.34751e-08L162 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 11.0642L162.707 15.3853L166.497 19.7063L170.287 15.3853L166.497 11.0642ZM162 15.3853L166.497 20.5126L170.994 15.3853L166.497 10.258L162 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 21.3325L162.707 25.6536L166.497 29.9746L170.287 25.6536L166.497 21.3325ZM162 25.6536L166.497 30.7808L170.994 25.6536L166.497 20.5263L162 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 0.806234L171.704 5.12728L175.494 9.44832L179.283 5.12728L175.494 0.806234ZM170.997 5.12728L175.494 10.2546L179.991 5.12728L175.494 -2.34751e-08L170.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 11.0642L171.704 15.3853L175.494 19.7063L179.283 15.3853L175.494 11.0642ZM170.997 15.3853L175.494 20.5126L179.991 15.3853L175.494 10.258L170.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 21.3325L171.704 25.6536L175.494 29.9746L179.283 25.6536L175.494 21.3325ZM170.997 25.6536L175.494 30.7808L179.991 25.6536L175.494 20.5263L170.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 0.806234L180.71 5.12728L184.499 9.44832L188.289 5.12728L184.499 0.806234ZM180.003 5.12728L184.499 10.2546L188.996 5.12728L184.499 -2.34751e-08L180.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 11.0642L180.71 15.3853L184.499 19.7063L188.289 15.3853L184.499 11.0642ZM180.003 15.3853L184.499 20.5126L188.996 15.3853L184.499 10.258L180.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 21.3325L180.71 25.6536L184.499 29.9746L188.289 25.6536L184.499 21.3325ZM180.003 25.6536L184.499 30.7808L188.996 25.6536L184.499 20.5263L180.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 31.5913L27.7071 35.9123L31.4969 40.2334L35.2866 35.9123L31.4969 31.5913ZM27 35.9123L31.4969 41.0396L35.9937 35.9123L31.4969 30.785L27 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 41.8493L27.7071 46.1703L31.4969 50.4914L35.2866 46.1703L31.4969 41.8493ZM27 46.1703L31.4969 51.2976L35.9937 46.1703L31.4969 41.043L27 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 52.1176L27.7071 56.4386L31.4969 60.7596L35.2866 56.4386L31.4969 52.1176ZM27 56.4386L31.4969 61.5659L35.9937 56.4386L31.4969 51.3113L27 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 31.5913L36.7039 35.9123L40.4936 40.2334L44.2834 35.9123L40.4936 31.5913ZM35.9968 35.9123L40.4936 41.0396L44.9905 35.9123L40.4936 30.785L35.9968 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 41.8493L36.7039 46.1703L40.4936 50.4914L44.2834 46.1703L40.4936 41.8493ZM35.9968 46.1703L40.4936 51.2976L44.9905 46.1703L40.4936 41.043L35.9968 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 52.1176L36.7039 56.4386L40.4936 60.7596L44.2834 56.4386L40.4936 52.1176ZM35.9968 56.4386L40.4936 61.5659L44.9905 56.4386L40.4936 51.3113L35.9968 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 31.5913L45.7097 35.9123L49.4994 40.2334L53.2892 35.9123L49.4994 31.5913ZM45.0026 35.9123L49.4994 41.0396L53.9963 35.9123L49.4994 30.785L45.0026 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 41.8493L45.7097 46.1703L49.4994 50.4914L53.2892 46.1703L49.4994 41.8493ZM45.0026 46.1703L49.4994 51.2976L53.9963 46.1703L49.4994 41.043L45.0026 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 52.1176L45.7097 56.4386L49.4994 60.7596L53.2892 56.4386L49.4994 52.1176ZM45.0026 56.4386L49.4994 61.5659L53.9963 56.4386L49.4994 51.3113L45.0026 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 31.5913L162.707 35.9123L166.497 40.2334L170.287 35.9123L166.497 31.5913ZM162 35.9123L166.497 41.0396L170.994 35.9123L166.497 30.785L162 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 41.8493L162.707 46.1703L166.497 50.4914L170.287 46.1703L166.497 41.8493ZM162 46.1703L166.497 51.2976L170.994 46.1703L166.497 41.043L162 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 52.1176L162.707 56.4386L166.497 60.7596L170.287 56.4386L166.497 52.1176ZM162 56.4386L166.497 61.5659L170.994 56.4386L166.497 51.3113L162 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 31.5913L171.704 35.9123L175.494 40.2334L179.283 35.9123L175.494 31.5913ZM170.997 35.9123L175.494 41.0396L179.991 35.9123L175.494 30.785L170.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 41.8493L171.704 46.1703L175.494 50.4914L179.283 46.1703L175.494 41.8493ZM170.997 46.1703L175.494 51.2976L179.991 46.1703L175.494 41.043L170.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 52.1176L171.704 56.4386L175.494 60.7596L179.283 56.4386L175.494 52.1176ZM170.997 56.4386L175.494 61.5659L179.991 56.4386L175.494 51.3113L170.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 31.5913L180.71 35.9123L184.499 40.2334L188.289 35.9123L184.499 31.5913ZM180.003 35.9123L184.499 41.0396L188.996 35.9123L184.499 30.785L180.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 41.8493L180.71 46.1703L184.499 50.4914L188.289 46.1703L184.499 41.8493ZM180.003 46.1703L184.499 51.2976L188.996 46.1703L184.499 41.043L180.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 52.1176L180.71 56.4386L184.499 60.7596L188.289 56.4386L184.499 52.1176ZM180.003 56.4386L184.499 61.5659L188.996 56.4386L184.499 51.3113L180.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 61.2361L27.7071 65.5572L31.4969 69.8782L35.2866 65.5572L31.4969 61.2361ZM27 65.5572L31.4969 70.6845L35.9937 65.5572L31.4969 60.4299L27 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 71.4941L27.7071 75.8152L31.4969 80.1362L35.2866 75.8152L31.4969 71.4941ZM27 75.8152L31.4969 80.9425L35.9937 75.8152L31.4969 70.6879L27 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 81.7624L27.7071 86.0835L31.4969 90.4045L35.2866 86.0835L31.4969 81.7624ZM27 86.0835L31.4969 91.2107L35.9937 86.0835L31.4969 80.9562L27 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 61.2361L36.7039 65.5572L40.4936 69.8782L44.2834 65.5572L40.4936 61.2361ZM35.9968 65.5572L40.4936 70.6845L44.9905 65.5572L40.4936 60.4299L35.9968 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 71.4941L36.7039 75.8152L40.4936 80.1362L44.2834 75.8152L40.4936 71.4941ZM35.9968 75.8152L40.4936 80.9425L44.9905 75.8152L40.4936 70.6879L35.9968 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 81.7624L36.7039 86.0835L40.4936 90.4045L44.2834 86.0835L40.4936 81.7624ZM35.9968 86.0835L40.4936 91.2107L44.9905 86.0835L40.4936 80.9562L35.9968 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 61.2361L45.7097 65.5572L49.4994 69.8782L53.2892 65.5572L49.4994 61.2361ZM45.0026 65.5572L49.4994 70.6845L53.9963 65.5572L49.4994 60.4299L45.0026 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 71.4941L45.7097 75.8152L49.4994 80.1362L53.2892 75.8152L49.4994 71.4941ZM45.0026 75.8152L49.4994 80.9425L53.9963 75.8152L49.4994 70.6879L45.0026 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 81.7624L45.7097 86.0835L49.4994 90.4045L53.2892 86.0835L49.4994 81.7624ZM45.0026 86.0835L49.4994 91.2107L53.9963 86.0835L49.4994 80.9562L45.0026 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 61.2361L162.707 65.5572L166.497 69.8782L170.287 65.5572L166.497 61.2361ZM162 65.5572L166.497 70.6845L170.994 65.5572L166.497 60.4299L162 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 71.4941L162.707 75.8152L166.497 80.1362L170.287 75.8152L166.497 71.4941ZM162 75.8152L166.497 80.9425L170.994 75.8152L166.497 70.6879L162 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 81.7624L162.707 86.0835L166.497 90.4045L170.287 86.0835L166.497 81.7624ZM162 86.0835L166.497 91.2107L170.994 86.0835L166.497 80.9562L162 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 61.2361L171.704 65.5572L175.494 69.8782L179.283 65.5572L175.494 61.2361ZM170.997 65.5572L175.494 70.6845L179.991 65.5572L175.494 60.4299L170.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 71.4941L171.704 75.8152L175.494 80.1362L179.283 75.8152L175.494 71.4941ZM170.997 75.8152L175.494 80.9425L179.991 75.8152L175.494 70.6879L170.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 81.7624L171.704 86.0835L175.494 90.4045L179.283 86.0835L175.494 81.7624ZM170.997 86.0835L175.494 91.2107L179.991 86.0835L175.494 80.9562L170.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 61.2361L180.71 65.5572L184.499 69.8782L188.289 65.5572L184.499 61.2361ZM180.003 65.5572L184.499 70.6845L188.996 65.5572L184.499 60.4299L180.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 71.4941L180.71 75.8152L184.499 80.1362L188.289 75.8152L184.499 71.4941ZM180.003 75.8152L184.499 80.9425L188.996 75.8152L184.499 70.6879L180.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 81.7624L180.71 86.0835L184.499 90.4045L188.289 86.0835L184.499 81.7624ZM180.003 86.0835L184.499 91.2107L188.996 86.0835L184.499 80.9562L180.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 92.0212L27.7071 96.3422L31.4969 100.663L35.2866 96.3422L31.4969 92.0212ZM27 96.3422L31.4969 101.47L35.9937 96.3422L31.4969 91.2149L27 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 102.279L27.7071 106.6L31.4969 110.921L35.2866 106.6L31.4969 102.279ZM27 106.6L31.4969 111.727L35.9937 106.6L31.4969 101.473L27 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4969 112.547L27.7071 116.869L31.4969 121.19L35.2866 116.869L31.4969 112.547ZM27 116.869L31.4969 121.996L35.9937 116.869L31.4969 111.741L27 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 92.0212L36.7039 96.3422L40.4936 100.663L44.2834 96.3422L40.4936 92.0212ZM35.9968 96.3422L40.4936 101.47L44.9905 96.3422L40.4936 91.2149L35.9968 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 102.279L36.7039 106.6L40.4936 110.921L44.2834 106.6L40.4936 102.279ZM35.9968 106.6L40.4936 111.727L44.9905 106.6L40.4936 101.473L35.9968 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4936 112.547L36.7039 116.869L40.4936 121.19L44.2834 116.869L40.4936 112.547ZM35.9968 116.869L40.4936 121.996L44.9905 116.869L40.4936 111.741L35.9968 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 92.0212L45.7097 96.3422L49.4994 100.663L53.2892 96.3422L49.4994 92.0212ZM45.0026 96.3422L49.4994 101.47L53.9963 96.3422L49.4994 91.2149L45.0026 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 102.279L45.7097 106.6L49.4994 110.921L53.2892 106.6L49.4994 102.279ZM45.0026 106.6L49.4994 111.727L53.9963 106.6L49.4994 101.473L45.0026 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4994 112.547L45.7097 116.869L49.4994 121.19L53.2892 116.869L49.4994 112.547ZM45.0026 116.869L49.4994 121.996L53.9963 116.869L49.4994 111.741L45.0026 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 92.0212L162.707 96.3422L166.497 100.663L170.287 96.3422L166.497 92.0212ZM162 96.3422L166.497 101.47L170.994 96.3422L166.497 91.2149L162 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 102.279L162.707 106.6L166.497 110.921L170.287 106.6L166.497 102.279ZM162 106.6L166.497 111.727L170.994 106.6L166.497 101.473L162 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.497 112.547L162.707 116.869L166.497 121.19L170.287 116.869L166.497 112.547ZM162 116.869L166.497 121.996L170.994 116.869L166.497 111.741L162 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 92.0212L171.704 96.3422L175.494 100.663L179.283 96.3422L175.494 92.0212ZM170.997 96.3422L175.494 101.47L179.991 96.3422L175.494 91.2149L170.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 102.279L171.704 106.6L175.494 110.921L179.283 106.6L175.494 102.279ZM170.997 106.6L175.494 111.727L179.991 106.6L175.494 101.473L170.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.494 112.547L171.704 116.869L175.494 121.19L179.283 116.869L175.494 112.547ZM170.997 116.869L175.494 121.996L179.991 116.869L175.494 111.741L170.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 92.0212L180.71 96.3422L184.499 100.663L188.289 96.3422L184.499 92.0212ZM180.003 96.3422L184.499 101.47L188.996 96.3422L184.499 91.2149L180.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 102.279L180.71 106.6L184.499 110.921L188.289 106.6L184.499 102.279ZM180.003 106.6L184.499 111.727L188.996 106.6L184.499 101.473L180.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.499 112.547L180.71 116.869L184.499 121.19L188.289 116.869L184.499 112.547ZM180.003 116.869L184.499 121.996L188.996 116.869L184.499 111.741L180.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 0.806234L54.7071 5.12728L58.4969 9.44832L62.2866 5.12728L58.4969 0.806234ZM54 5.12728L58.4969 10.2546L62.9937 5.12728L58.4969 -2.34751e-08L54 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 11.0642L54.7071 15.3853L58.4969 19.7063L62.2866 15.3853L58.4969 11.0642ZM54 15.3853L58.4969 20.5126L62.9937 15.3853L58.4969 10.258L54 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 21.3325L54.7071 25.6536L58.4969 29.9746L62.2866 25.6536L58.4969 21.3325ZM54 25.6536L58.4969 30.7808L62.9937 25.6536L58.4969 20.5263L54 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 0.806234L63.7039 5.12728L67.4936 9.44832L71.2834 5.12728L67.4936 0.806234ZM62.9968 5.12728L67.4936 10.2546L71.9905 5.12728L67.4936 -2.34751e-08L62.9968 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 11.0642L63.7039 15.3853L67.4936 19.7063L71.2834 15.3853L67.4936 11.0642ZM62.9968 15.3853L67.4936 20.5126L71.9905 15.3853L67.4936 10.258L62.9968 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 21.3325L63.7039 25.6536L67.4936 29.9746L71.2834 25.6536L67.4936 21.3325ZM62.9968 25.6536L67.4936 30.7808L71.9905 25.6536L67.4936 20.5263L62.9968 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 0.806234L72.7097 5.12728L76.4994 9.44832L80.2892 5.12728L76.4994 0.806234ZM72.0026 5.12728L76.4994 10.2546L80.9963 5.12728L76.4994 -2.34751e-08L72.0026 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 11.0642L72.7097 15.3853L76.4994 19.7063L80.2892 15.3853L76.4994 11.0642ZM72.0026 15.3853L76.4994 20.5126L80.9963 15.3853L76.4994 10.258L72.0026 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 21.3325L72.7097 25.6536L76.4994 29.9746L80.2892 25.6536L76.4994 21.3325ZM72.0026 25.6536L76.4994 30.7808L80.9963 25.6536L76.4994 20.5263L72.0026 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 0.806234L189.707 5.12728L193.497 9.44832L197.287 5.12728L193.497 0.806234ZM189 5.12728L193.497 10.2546L197.994 5.12728L193.497 -2.34751e-08L189 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 11.0642L189.707 15.3853L193.497 19.7063L197.287 15.3853L193.497 11.0642ZM189 15.3853L193.497 20.5126L197.994 15.3853L193.497 10.258L189 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 21.3325L189.707 25.6536L193.497 29.9746L197.287 25.6536L193.497 21.3325ZM189 25.6536L193.497 30.7808L197.994 25.6536L193.497 20.5263L189 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 0.806234L198.704 5.12728L202.494 9.44832L206.283 5.12728L202.494 0.806234ZM197.997 5.12728L202.494 10.2546L206.991 5.12728L202.494 -2.34751e-08L197.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 11.0642L198.704 15.3853L202.494 19.7063L206.283 15.3853L202.494 11.0642ZM197.997 15.3853L202.494 20.5126L206.991 15.3853L202.494 10.258L197.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 21.3325L198.704 25.6536L202.494 29.9746L206.283 25.6536L202.494 21.3325ZM197.997 25.6536L202.494 30.7808L206.991 25.6536L202.494 20.5263L197.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 0.806234L207.71 5.12728L211.499 9.44832L215.289 5.12728L211.499 0.806234ZM207.003 5.12728L211.499 10.2546L215.996 5.12728L211.499 -2.34751e-08L207.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 11.0642L207.71 15.3853L211.499 19.7063L215.289 15.3853L211.499 11.0642ZM207.003 15.3853L211.499 20.5126L215.996 15.3853L211.499 10.258L207.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 21.3325L207.71 25.6536L211.499 29.9746L215.289 25.6536L211.499 21.3325ZM207.003 25.6536L211.499 30.7808L215.996 25.6536L211.499 20.5263L207.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 0.806234L270.707 5.12728L274.497 9.44832L278.287 5.12728L274.497 0.806234ZM270 5.12728L274.497 10.2546L278.994 5.12728L274.497 -2.34751e-08L270 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 11.0642L270.707 15.3853L274.497 19.7063L278.287 15.3853L274.497 11.0642ZM270 15.3853L274.497 20.5126L278.994 15.3853L274.497 10.258L270 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 21.3325L270.707 25.6536L274.497 29.9746L278.287 25.6536L274.497 21.3325ZM270 25.6536L274.497 30.7808L278.994 25.6536L274.497 20.5263L270 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 0.806234L279.704 5.12728L283.494 9.44832L287.283 5.12728L283.494 0.806234ZM278.997 5.12728L283.494 10.2546L287.991 5.12728L283.494 -2.34751e-08L278.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 11.0642L279.704 15.3853L283.494 19.7063L287.283 15.3853L283.494 11.0642ZM278.997 15.3853L283.494 20.5126L287.991 15.3853L283.494 10.258L278.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 21.3325L279.704 25.6536L283.494 29.9746L287.283 25.6536L283.494 21.3325ZM278.997 25.6536L283.494 30.7808L287.991 25.6536L283.494 20.5263L278.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 0.806234L288.71 5.12728L292.499 9.44832L296.289 5.12728L292.499 0.806234ZM288.003 5.12728L292.499 10.2546L296.996 5.12728L292.499 -2.34751e-08L288.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 11.0642L288.71 15.3853L292.499 19.7063L296.289 15.3853L292.499 11.0642ZM288.003 15.3853L292.499 20.5126L296.996 15.3853L292.499 10.258L288.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 21.3325L288.71 25.6536L292.499 29.9746L296.289 25.6536L292.499 21.3325ZM288.003 25.6536L292.499 30.7808L296.996 25.6536L292.499 20.5263L288.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 31.5913L54.7071 35.9123L58.4969 40.2334L62.2866 35.9123L58.4969 31.5913ZM54 35.9123L58.4969 41.0396L62.9937 35.9123L58.4969 30.785L54 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 41.8493L54.7071 46.1703L58.4969 50.4914L62.2866 46.1703L58.4969 41.8493ZM54 46.1703L58.4969 51.2976L62.9937 46.1703L58.4969 41.043L54 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 52.1176L54.7071 56.4386L58.4969 60.7596L62.2866 56.4386L58.4969 52.1176ZM54 56.4386L58.4969 61.5659L62.9937 56.4386L58.4969 51.3113L54 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 31.5913L63.7039 35.9123L67.4936 40.2334L71.2834 35.9123L67.4936 31.5913ZM62.9968 35.9123L67.4936 41.0396L71.9905 35.9123L67.4936 30.785L62.9968 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 41.8493L63.7039 46.1703L67.4936 50.4914L71.2834 46.1703L67.4936 41.8493ZM62.9968 46.1703L67.4936 51.2976L71.9905 46.1703L67.4936 41.043L62.9968 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 52.1176L63.7039 56.4386L67.4936 60.7596L71.2834 56.4386L67.4936 52.1176ZM62.9968 56.4386L67.4936 61.5659L71.9905 56.4386L67.4936 51.3113L62.9968 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 31.5913L72.7097 35.9123L76.4994 40.2334L80.2892 35.9123L76.4994 31.5913ZM72.0026 35.9123L76.4994 41.0396L80.9963 35.9123L76.4994 30.785L72.0026 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 41.8493L72.7097 46.1703L76.4994 50.4914L80.2892 46.1703L76.4994 41.8493ZM72.0026 46.1703L76.4994 51.2976L80.9963 46.1703L76.4994 41.043L72.0026 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 52.1176L72.7097 56.4386L76.4994 60.7596L80.2892 56.4386L76.4994 52.1176ZM72.0026 56.4386L76.4994 61.5659L80.9963 56.4386L76.4994 51.3113L72.0026 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 31.5913L189.707 35.9123L193.497 40.2334L197.287 35.9123L193.497 31.5913ZM189 35.9123L193.497 41.0396L197.994 35.9123L193.497 30.785L189 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 41.8493L189.707 46.1703L193.497 50.4914L197.287 46.1703L193.497 41.8493ZM189 46.1703L193.497 51.2976L197.994 46.1703L193.497 41.043L189 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 52.1176L189.707 56.4386L193.497 60.7596L197.287 56.4386L193.497 52.1176ZM189 56.4386L193.497 61.5659L197.994 56.4386L193.497 51.3113L189 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 31.5913L198.704 35.9123L202.494 40.2334L206.283 35.9123L202.494 31.5913ZM197.997 35.9123L202.494 41.0396L206.991 35.9123L202.494 30.785L197.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 41.8493L198.704 46.1703L202.494 50.4914L206.283 46.1703L202.494 41.8493ZM197.997 46.1703L202.494 51.2976L206.991 46.1703L202.494 41.043L197.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 52.1176L198.704 56.4386L202.494 60.7596L206.283 56.4386L202.494 52.1176ZM197.997 56.4386L202.494 61.5659L206.991 56.4386L202.494 51.3113L197.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 31.5913L207.71 35.9123L211.499 40.2334L215.289 35.9123L211.499 31.5913ZM207.003 35.9123L211.499 41.0396L215.996 35.9123L211.499 30.785L207.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 41.8493L207.71 46.1703L211.499 50.4914L215.289 46.1703L211.499 41.8493ZM207.003 46.1703L211.499 51.2976L215.996 46.1703L211.499 41.043L207.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 52.1176L207.71 56.4386L211.499 60.7596L215.289 56.4386L211.499 52.1176ZM207.003 56.4386L211.499 61.5659L215.996 56.4386L211.499 51.3113L207.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 31.5913L270.707 35.9123L274.497 40.2334L278.287 35.9123L274.497 31.5913ZM270 35.9123L274.497 41.0396L278.994 35.9123L274.497 30.785L270 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 41.8493L270.707 46.1703L274.497 50.4914L278.287 46.1703L274.497 41.8493ZM270 46.1703L274.497 51.2976L278.994 46.1703L274.497 41.043L270 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 52.1176L270.707 56.4386L274.497 60.7596L278.287 56.4386L274.497 52.1176ZM270 56.4386L274.497 61.5659L278.994 56.4386L274.497 51.3113L270 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 31.5913L279.704 35.9123L283.494 40.2334L287.283 35.9123L283.494 31.5913ZM278.997 35.9123L283.494 41.0396L287.991 35.9123L283.494 30.785L278.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 41.8493L279.704 46.1703L283.494 50.4914L287.283 46.1703L283.494 41.8493ZM278.997 46.1703L283.494 51.2976L287.991 46.1703L283.494 41.043L278.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 52.1176L279.704 56.4386L283.494 60.7596L287.283 56.4386L283.494 52.1176ZM278.997 56.4386L283.494 61.5659L287.991 56.4386L283.494 51.3113L278.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 31.5913L288.71 35.9123L292.499 40.2334L296.289 35.9123L292.499 31.5913ZM288.003 35.9123L292.499 41.0396L296.996 35.9123L292.499 30.785L288.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 41.8493L288.71 46.1703L292.499 50.4914L296.289 46.1703L292.499 41.8493ZM288.003 46.1703L292.499 51.2976L296.996 46.1703L292.499 41.043L288.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 52.1176L288.71 56.4386L292.499 60.7596L296.289 56.4386L292.499 52.1176ZM288.003 56.4386L292.499 61.5659L296.996 56.4386L292.499 51.3113L288.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 61.2361L54.7071 65.5572L58.4969 69.8782L62.2866 65.5572L58.4969 61.2361ZM54 65.5572L58.4969 70.6845L62.9937 65.5572L58.4969 60.4299L54 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 71.4941L54.7071 75.8152L58.4969 80.1362L62.2866 75.8152L58.4969 71.4941ZM54 75.8152L58.4969 80.9425L62.9937 75.8152L58.4969 70.6879L54 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 81.7624L54.7071 86.0835L58.4969 90.4045L62.2866 86.0835L58.4969 81.7624ZM54 86.0835L58.4969 91.2107L62.9937 86.0835L58.4969 80.9562L54 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 61.2361L63.7039 65.5572L67.4936 69.8782L71.2834 65.5572L67.4936 61.2361ZM62.9968 65.5572L67.4936 70.6845L71.9905 65.5572L67.4936 60.4299L62.9968 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 71.4941L63.7039 75.8152L67.4936 80.1362L71.2834 75.8152L67.4936 71.4941ZM62.9968 75.8152L67.4936 80.9425L71.9905 75.8152L67.4936 70.6879L62.9968 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 81.7624L63.7039 86.0835L67.4936 90.4045L71.2834 86.0835L67.4936 81.7624ZM62.9968 86.0835L67.4936 91.2107L71.9905 86.0835L67.4936 80.9562L62.9968 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 61.2361L72.7097 65.5572L76.4994 69.8782L80.2892 65.5572L76.4994 61.2361ZM72.0026 65.5572L76.4994 70.6845L80.9963 65.5572L76.4994 60.4299L72.0026 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 71.4941L72.7097 75.8152L76.4994 80.1362L80.2892 75.8152L76.4994 71.4941ZM72.0026 75.8152L76.4994 80.9425L80.9963 75.8152L76.4994 70.6879L72.0026 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 81.7624L72.7097 86.0835L76.4994 90.4045L80.2892 86.0835L76.4994 81.7624ZM72.0026 86.0835L76.4994 91.2107L80.9963 86.0835L76.4994 80.9562L72.0026 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 61.2361L189.707 65.5572L193.497 69.8782L197.287 65.5572L193.497 61.2361ZM189 65.5572L193.497 70.6845L197.994 65.5572L193.497 60.4299L189 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 71.4941L189.707 75.8152L193.497 80.1362L197.287 75.8152L193.497 71.4941ZM189 75.8152L193.497 80.9425L197.994 75.8152L193.497 70.6879L189 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 81.7624L189.707 86.0835L193.497 90.4045L197.287 86.0835L193.497 81.7624ZM189 86.0835L193.497 91.2107L197.994 86.0835L193.497 80.9562L189 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 61.2361L198.704 65.5572L202.494 69.8782L206.283 65.5572L202.494 61.2361ZM197.997 65.5572L202.494 70.6845L206.991 65.5572L202.494 60.4299L197.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 71.4941L198.704 75.8152L202.494 80.1362L206.283 75.8152L202.494 71.4941ZM197.997 75.8152L202.494 80.9425L206.991 75.8152L202.494 70.6879L197.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 81.7624L198.704 86.0835L202.494 90.4045L206.283 86.0835L202.494 81.7624ZM197.997 86.0835L202.494 91.2107L206.991 86.0835L202.494 80.9562L197.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 61.2361L207.71 65.5572L211.499 69.8782L215.289 65.5572L211.499 61.2361ZM207.003 65.5572L211.499 70.6845L215.996 65.5572L211.499 60.4299L207.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 71.4941L207.71 75.8152L211.499 80.1362L215.289 75.8152L211.499 71.4941ZM207.003 75.8152L211.499 80.9425L215.996 75.8152L211.499 70.6879L207.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 81.7624L207.71 86.0835L211.499 90.4045L215.289 86.0835L211.499 81.7624ZM207.003 86.0835L211.499 91.2107L215.996 86.0835L211.499 80.9562L207.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 61.2361L270.707 65.5572L274.497 69.8782L278.287 65.5572L274.497 61.2361ZM270 65.5572L274.497 70.6845L278.994 65.5572L274.497 60.4299L270 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 71.4941L270.707 75.8152L274.497 80.1362L278.287 75.8152L274.497 71.4941ZM270 75.8152L274.497 80.9425L278.994 75.8152L274.497 70.6879L270 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 81.7624L270.707 86.0835L274.497 90.4045L278.287 86.0835L274.497 81.7624ZM270 86.0835L274.497 91.2107L278.994 86.0835L274.497 80.9562L270 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 61.2361L279.704 65.5572L283.494 69.8782L287.283 65.5572L283.494 61.2361ZM278.997 65.5572L283.494 70.6845L287.991 65.5572L283.494 60.4299L278.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 71.4941L279.704 75.8152L283.494 80.1362L287.283 75.8152L283.494 71.4941ZM278.997 75.8152L283.494 80.9425L287.991 75.8152L283.494 70.6879L278.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 81.7624L279.704 86.0835L283.494 90.4045L287.283 86.0835L283.494 81.7624ZM278.997 86.0835L283.494 91.2107L287.991 86.0835L283.494 80.9562L278.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 61.2361L288.71 65.5572L292.499 69.8782L296.289 65.5572L292.499 61.2361ZM288.003 65.5572L292.499 70.6845L296.996 65.5572L292.499 60.4299L288.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 71.4941L288.71 75.8152L292.499 80.1362L296.289 75.8152L292.499 71.4941ZM288.003 75.8152L292.499 80.9425L296.996 75.8152L292.499 70.6879L288.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 81.7624L288.71 86.0835L292.499 90.4045L296.289 86.0835L292.499 81.7624ZM288.003 86.0835L292.499 91.2107L296.996 86.0835L292.499 80.9562L288.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 92.0212L54.7071 96.3422L58.4969 100.663L62.2866 96.3422L58.4969 92.0212ZM54 96.3422L58.4969 101.47L62.9937 96.3422L58.4969 91.2149L54 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 102.279L54.7071 106.6L58.4969 110.921L62.2866 106.6L58.4969 102.279ZM54 106.6L58.4969 111.727L62.9937 106.6L58.4969 101.473L54 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4969 112.547L54.7071 116.869L58.4969 121.19L62.2866 116.869L58.4969 112.547ZM54 116.869L58.4969 121.996L62.9937 116.869L58.4969 111.741L54 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 92.0212L63.7039 96.3422L67.4936 100.663L71.2834 96.3422L67.4936 92.0212ZM62.9968 96.3422L67.4936 101.47L71.9905 96.3422L67.4936 91.2149L62.9968 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 102.279L63.7039 106.6L67.4936 110.921L71.2834 106.6L67.4936 102.279ZM62.9968 106.6L67.4936 111.727L71.9905 106.6L67.4936 101.473L62.9968 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4936 112.547L63.7039 116.869L67.4936 121.19L71.2834 116.869L67.4936 112.547ZM62.9968 116.869L67.4936 121.996L71.9905 116.869L67.4936 111.741L62.9968 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 92.0212L72.7097 96.3422L76.4994 100.663L80.2892 96.3422L76.4994 92.0212ZM72.0026 96.3422L76.4994 101.47L80.9963 96.3422L76.4994 91.2149L72.0026 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 102.279L72.7097 106.6L76.4994 110.921L80.2892 106.6L76.4994 102.279ZM72.0026 106.6L76.4994 111.727L80.9963 106.6L76.4994 101.473L72.0026 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4994 112.547L72.7097 116.869L76.4994 121.19L80.2892 116.869L76.4994 112.547ZM72.0026 116.869L76.4994 121.996L80.9963 116.869L76.4994 111.741L72.0026 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 92.0212L189.707 96.3422L193.497 100.663L197.287 96.3422L193.497 92.0212ZM189 96.3422L193.497 101.47L197.994 96.3422L193.497 91.2149L189 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 102.279L189.707 106.6L193.497 110.921L197.287 106.6L193.497 102.279ZM189 106.6L193.497 111.727L197.994 106.6L193.497 101.473L189 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.497 112.547L189.707 116.869L193.497 121.19L197.287 116.869L193.497 112.547ZM189 116.869L193.497 121.996L197.994 116.869L193.497 111.741L189 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 92.0212L198.704 96.3422L202.494 100.663L206.283 96.3422L202.494 92.0212ZM197.997 96.3422L202.494 101.47L206.991 96.3422L202.494 91.2149L197.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 102.279L198.704 106.6L202.494 110.921L206.283 106.6L202.494 102.279ZM197.997 106.6L202.494 111.727L206.991 106.6L202.494 101.473L197.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.494 112.547L198.704 116.869L202.494 121.19L206.283 116.869L202.494 112.547ZM197.997 116.869L202.494 121.996L206.991 116.869L202.494 111.741L197.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 92.0212L207.71 96.3422L211.499 100.663L215.289 96.3422L211.499 92.0212ZM207.003 96.3422L211.499 101.47L215.996 96.3422L211.499 91.2149L207.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 102.279L207.71 106.6L211.499 110.921L215.289 106.6L211.499 102.279ZM207.003 106.6L211.499 111.727L215.996 106.6L211.499 101.473L207.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.499 112.547L207.71 116.869L211.499 121.19L215.289 116.869L211.499 112.547ZM207.003 116.869L211.499 121.996L215.996 116.869L211.499 111.741L207.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 92.0212L270.707 96.3422L274.497 100.663L278.287 96.3422L274.497 92.0212ZM270 96.3422L274.497 101.47L278.994 96.3422L274.497 91.2149L270 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 102.279L270.707 106.6L274.497 110.921L278.287 106.6L274.497 102.279ZM270 106.6L274.497 111.727L278.994 106.6L274.497 101.473L270 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.497 112.547L270.707 116.869L274.497 121.19L278.287 116.869L274.497 112.547ZM270 116.869L274.497 121.996L278.994 116.869L274.497 111.741L270 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 92.0212L279.704 96.3422L283.494 100.663L287.283 96.3422L283.494 92.0212ZM278.997 96.3422L283.494 101.47L287.991 96.3422L283.494 91.2149L278.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 102.279L279.704 106.6L283.494 110.921L287.283 106.6L283.494 102.279ZM278.997 106.6L283.494 111.727L287.991 106.6L283.494 101.473L278.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.494 112.547L279.704 116.869L283.494 121.19L287.283 116.869L283.494 112.547ZM278.997 116.869L283.494 121.996L287.991 116.869L283.494 111.741L278.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 92.0212L288.71 96.3422L292.499 100.663L296.289 96.3422L292.499 92.0212ZM288.003 96.3422L292.499 101.47L296.996 96.3422L292.499 91.2149L288.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 102.279L288.71 106.6L292.499 110.921L296.289 106.6L292.499 102.279ZM288.003 106.6L292.499 111.727L296.996 106.6L292.499 101.473L288.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.499 112.547L288.71 116.869L292.499 121.19L296.289 116.869L292.499 112.547ZM288.003 116.869L292.499 121.996L296.996 116.869L292.499 111.741L288.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 0.806234L81.7071 5.12728L85.4969 9.44832L89.2866 5.12728L85.4969 0.806234ZM81 5.12728L85.4969 10.2546L89.9937 5.12728L85.4969 -2.34751e-08L81 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 11.0642L81.7071 15.3853L85.4969 19.7063L89.2866 15.3853L85.4969 11.0642ZM81 15.3853L85.4969 20.5126L89.9937 15.3853L85.4969 10.258L81 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 21.3325L81.7071 25.6536L85.4969 29.9746L89.2866 25.6536L85.4969 21.3325ZM81 25.6536L85.4969 30.7808L89.9937 25.6536L85.4969 20.5263L81 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 0.806234L90.7039 5.12728L94.4936 9.44832L98.2834 5.12728L94.4936 0.806234ZM89.9968 5.12728L94.4936 10.2546L98.9905 5.12728L94.4936 -2.34751e-08L89.9968 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 11.0642L90.7039 15.3853L94.4936 19.7063L98.2834 15.3853L94.4936 11.0642ZM89.9968 15.3853L94.4936 20.5126L98.9905 15.3853L94.4936 10.258L89.9968 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 21.3325L90.7039 25.6536L94.4936 29.9746L98.2834 25.6536L94.4936 21.3325ZM89.9968 25.6536L94.4936 30.7808L98.9905 25.6536L94.4936 20.5263L89.9968 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 0.806234L99.7097 5.12728L103.499 9.44832L107.289 5.12728L103.499 0.806234ZM99.0026 5.12728L103.499 10.2546L107.996 5.12728L103.499 -2.34751e-08L99.0026 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 11.0642L99.7097 15.3853L103.499 19.7063L107.289 15.3853L103.499 11.0642ZM99.0026 15.3853L103.499 20.5126L107.996 15.3853L103.499 10.258L99.0026 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 21.3325L99.7097 25.6536L103.499 29.9746L107.289 25.6536L103.499 21.3325ZM99.0026 25.6536L103.499 30.7808L107.996 25.6536L103.499 20.5263L99.0026 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 0.806234L216.707 5.12728L220.497 9.44832L224.287 5.12728L220.497 0.806234ZM216 5.12728L220.497 10.2546L224.994 5.12728L220.497 -2.34751e-08L216 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 11.0642L216.707 15.3853L220.497 19.7063L224.287 15.3853L220.497 11.0642ZM216 15.3853L220.497 20.5126L224.994 15.3853L220.497 10.258L216 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 21.3325L216.707 25.6536L220.497 29.9746L224.287 25.6536L220.497 21.3325ZM216 25.6536L220.497 30.7808L224.994 25.6536L220.497 20.5263L216 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 0.806234L225.704 5.12728L229.494 9.44832L233.283 5.12728L229.494 0.806234ZM224.997 5.12728L229.494 10.2546L233.991 5.12728L229.494 -2.34751e-08L224.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 11.0642L225.704 15.3853L229.494 19.7063L233.283 15.3853L229.494 11.0642ZM224.997 15.3853L229.494 20.5126L233.991 15.3853L229.494 10.258L224.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 21.3325L225.704 25.6536L229.494 29.9746L233.283 25.6536L229.494 21.3325ZM224.997 25.6536L229.494 30.7808L233.991 25.6536L229.494 20.5263L224.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 0.806234L234.71 5.12728L238.499 9.44832L242.289 5.12728L238.499 0.806234ZM234.003 5.12728L238.499 10.2546L242.996 5.12728L238.499 -2.34751e-08L234.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 11.0642L234.71 15.3853L238.499 19.7063L242.289 15.3853L238.499 11.0642ZM234.003 15.3853L238.499 20.5126L242.996 15.3853L238.499 10.258L234.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 21.3325L234.71 25.6536L238.499 29.9746L242.289 25.6536L238.499 21.3325ZM234.003 25.6536L238.499 30.7808L242.996 25.6536L238.499 20.5263L234.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 0.806234L297.707 5.12728L301.497 9.44832L305.287 5.12728L301.497 0.806234ZM297 5.12728L301.497 10.2546L305.994 5.12728L301.497 -2.34751e-08L297 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 11.0642L297.707 15.3853L301.497 19.7063L305.287 15.3853L301.497 11.0642ZM297 15.3853L301.497 20.5126L305.994 15.3853L301.497 10.258L297 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 21.3325L297.707 25.6536L301.497 29.9746L305.287 25.6536L301.497 21.3325ZM297 25.6536L301.497 30.7808L305.994 25.6536L301.497 20.5263L297 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 0.806234L306.704 5.12728L310.494 9.44832L314.283 5.12728L310.494 0.806234ZM305.997 5.12728L310.494 10.2546L314.991 5.12728L310.494 -2.34751e-08L305.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 11.0642L306.704 15.3853L310.494 19.7063L314.283 15.3853L310.494 11.0642ZM305.997 15.3853L310.494 20.5126L314.991 15.3853L310.494 10.258L305.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 21.3325L306.704 25.6536L310.494 29.9746L314.283 25.6536L310.494 21.3325ZM305.997 25.6536L310.494 30.7808L314.991 25.6536L310.494 20.5263L305.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 0.806234L315.71 5.12728L319.499 9.44832L323.289 5.12728L319.499 0.806234ZM315.003 5.12728L319.499 10.2546L323.996 5.12728L319.499 -2.34751e-08L315.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 11.0642L315.71 15.3853L319.499 19.7063L323.289 15.3853L319.499 11.0642ZM315.003 15.3853L319.499 20.5126L323.996 15.3853L319.499 10.258L315.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 21.3325L315.71 25.6536L319.499 29.9746L323.289 25.6536L319.499 21.3325ZM315.003 25.6536L319.499 30.7808L323.996 25.6536L319.499 20.5263L315.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 31.5913L81.7071 35.9123L85.4969 40.2334L89.2866 35.9123L85.4969 31.5913ZM81 35.9123L85.4969 41.0396L89.9937 35.9123L85.4969 30.785L81 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 41.8493L81.7071 46.1703L85.4969 50.4914L89.2866 46.1703L85.4969 41.8493ZM81 46.1703L85.4969 51.2976L89.9937 46.1703L85.4969 41.043L81 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 52.1176L81.7071 56.4386L85.4969 60.7596L89.2866 56.4386L85.4969 52.1176ZM81 56.4386L85.4969 61.5659L89.9937 56.4386L85.4969 51.3113L81 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 31.5913L90.7039 35.9123L94.4936 40.2334L98.2834 35.9123L94.4936 31.5913ZM89.9968 35.9123L94.4936 41.0396L98.9905 35.9123L94.4936 30.785L89.9968 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 41.8493L90.7039 46.1703L94.4936 50.4914L98.2834 46.1703L94.4936 41.8493ZM89.9968 46.1703L94.4936 51.2976L98.9905 46.1703L94.4936 41.043L89.9968 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 52.1176L90.7039 56.4386L94.4936 60.7596L98.2834 56.4386L94.4936 52.1176ZM89.9968 56.4386L94.4936 61.5659L98.9905 56.4386L94.4936 51.3113L89.9968 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 31.5913L99.7097 35.9123L103.499 40.2334L107.289 35.9123L103.499 31.5913ZM99.0026 35.9123L103.499 41.0396L107.996 35.9123L103.499 30.785L99.0026 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 41.8493L99.7097 46.1703L103.499 50.4914L107.289 46.1703L103.499 41.8493ZM99.0026 46.1703L103.499 51.2976L107.996 46.1703L103.499 41.043L99.0026 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 52.1176L99.7097 56.4386L103.499 60.7596L107.289 56.4386L103.499 52.1176ZM99.0026 56.4386L103.499 61.5659L107.996 56.4386L103.499 51.3113L99.0026 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 31.5913L216.707 35.9123L220.497 40.2334L224.287 35.9123L220.497 31.5913ZM216 35.9123L220.497 41.0396L224.994 35.9123L220.497 30.785L216 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 41.8493L216.707 46.1703L220.497 50.4914L224.287 46.1703L220.497 41.8493ZM216 46.1703L220.497 51.2976L224.994 46.1703L220.497 41.043L216 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 52.1176L216.707 56.4386L220.497 60.7596L224.287 56.4386L220.497 52.1176ZM216 56.4386L220.497 61.5659L224.994 56.4386L220.497 51.3113L216 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 31.5913L225.704 35.9123L229.494 40.2334L233.283 35.9123L229.494 31.5913ZM224.997 35.9123L229.494 41.0396L233.991 35.9123L229.494 30.785L224.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 41.8493L225.704 46.1703L229.494 50.4914L233.283 46.1703L229.494 41.8493ZM224.997 46.1703L229.494 51.2976L233.991 46.1703L229.494 41.043L224.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 52.1176L225.704 56.4386L229.494 60.7596L233.283 56.4386L229.494 52.1176ZM224.997 56.4386L229.494 61.5659L233.991 56.4386L229.494 51.3113L224.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 31.5913L234.71 35.9123L238.499 40.2334L242.289 35.9123L238.499 31.5913ZM234.003 35.9123L238.499 41.0396L242.996 35.9123L238.499 30.785L234.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 41.8493L234.71 46.1703L238.499 50.4914L242.289 46.1703L238.499 41.8493ZM234.003 46.1703L238.499 51.2976L242.996 46.1703L238.499 41.043L234.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 52.1176L234.71 56.4386L238.499 60.7596L242.289 56.4386L238.499 52.1176ZM234.003 56.4386L238.499 61.5659L242.996 56.4386L238.499 51.3113L234.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 31.5913L297.707 35.9123L301.497 40.2334L305.287 35.9123L301.497 31.5913ZM297 35.9123L301.497 41.0396L305.994 35.9123L301.497 30.785L297 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 41.8493L297.707 46.1703L301.497 50.4914L305.287 46.1703L301.497 41.8493ZM297 46.1703L301.497 51.2976L305.994 46.1703L301.497 41.043L297 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 52.1176L297.707 56.4386L301.497 60.7596L305.287 56.4386L301.497 52.1176ZM297 56.4386L301.497 61.5659L305.994 56.4386L301.497 51.3113L297 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 31.5913L306.704 35.9123L310.494 40.2334L314.283 35.9123L310.494 31.5913ZM305.997 35.9123L310.494 41.0396L314.991 35.9123L310.494 30.785L305.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 41.8493L306.704 46.1703L310.494 50.4914L314.283 46.1703L310.494 41.8493ZM305.997 46.1703L310.494 51.2976L314.991 46.1703L310.494 41.043L305.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 52.1176L306.704 56.4386L310.494 60.7596L314.283 56.4386L310.494 52.1176ZM305.997 56.4386L310.494 61.5659L314.991 56.4386L310.494 51.3113L305.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 31.5913L315.71 35.9123L319.499 40.2334L323.289 35.9123L319.499 31.5913ZM315.003 35.9123L319.499 41.0396L323.996 35.9123L319.499 30.785L315.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 41.8493L315.71 46.1703L319.499 50.4914L323.289 46.1703L319.499 41.8493ZM315.003 46.1703L319.499 51.2976L323.996 46.1703L319.499 41.043L315.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 52.1176L315.71 56.4386L319.499 60.7596L323.289 56.4386L319.499 52.1176ZM315.003 56.4386L319.499 61.5659L323.996 56.4386L319.499 51.3113L315.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 61.2361L81.7071 65.5572L85.4969 69.8782L89.2866 65.5572L85.4969 61.2361ZM81 65.5572L85.4969 70.6845L89.9937 65.5572L85.4969 60.4299L81 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 71.4941L81.7071 75.8152L85.4969 80.1362L89.2866 75.8152L85.4969 71.4941ZM81 75.8152L85.4969 80.9425L89.9937 75.8152L85.4969 70.6879L81 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 81.7624L81.7071 86.0835L85.4969 90.4045L89.2866 86.0835L85.4969 81.7624ZM81 86.0835L85.4969 91.2107L89.9937 86.0835L85.4969 80.9562L81 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 61.2361L90.7039 65.5572L94.4936 69.8782L98.2834 65.5572L94.4936 61.2361ZM89.9968 65.5572L94.4936 70.6845L98.9905 65.5572L94.4936 60.4299L89.9968 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 71.4941L90.7039 75.8152L94.4936 80.1362L98.2834 75.8152L94.4936 71.4941ZM89.9968 75.8152L94.4936 80.9425L98.9905 75.8152L94.4936 70.6879L89.9968 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 81.7624L90.7039 86.0835L94.4936 90.4045L98.2834 86.0835L94.4936 81.7624ZM89.9968 86.0835L94.4936 91.2107L98.9905 86.0835L94.4936 80.9562L89.9968 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 61.2361L99.7097 65.5572L103.499 69.8782L107.289 65.5572L103.499 61.2361ZM99.0026 65.5572L103.499 70.6845L107.996 65.5572L103.499 60.4299L99.0026 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 71.4941L99.7097 75.8152L103.499 80.1362L107.289 75.8152L103.499 71.4941ZM99.0026 75.8152L103.499 80.9425L107.996 75.8152L103.499 70.6879L99.0026 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 81.7624L99.7097 86.0835L103.499 90.4045L107.289 86.0835L103.499 81.7624ZM99.0026 86.0835L103.499 91.2107L107.996 86.0835L103.499 80.9562L99.0026 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 61.2361L216.707 65.5572L220.497 69.8782L224.287 65.5572L220.497 61.2361ZM216 65.5572L220.497 70.6845L224.994 65.5572L220.497 60.4299L216 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 71.4941L216.707 75.8152L220.497 80.1362L224.287 75.8152L220.497 71.4941ZM216 75.8152L220.497 80.9425L224.994 75.8152L220.497 70.6879L216 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 81.7624L216.707 86.0835L220.497 90.4045L224.287 86.0835L220.497 81.7624ZM216 86.0835L220.497 91.2107L224.994 86.0835L220.497 80.9562L216 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 61.2361L225.704 65.5572L229.494 69.8782L233.283 65.5572L229.494 61.2361ZM224.997 65.5572L229.494 70.6845L233.991 65.5572L229.494 60.4299L224.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 71.4941L225.704 75.8152L229.494 80.1362L233.283 75.8152L229.494 71.4941ZM224.997 75.8152L229.494 80.9425L233.991 75.8152L229.494 70.6879L224.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 81.7624L225.704 86.0835L229.494 90.4045L233.283 86.0835L229.494 81.7624ZM224.997 86.0835L229.494 91.2107L233.991 86.0835L229.494 80.9562L224.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 61.2361L234.71 65.5572L238.499 69.8782L242.289 65.5572L238.499 61.2361ZM234.003 65.5572L238.499 70.6845L242.996 65.5572L238.499 60.4299L234.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 71.4941L234.71 75.8152L238.499 80.1362L242.289 75.8152L238.499 71.4941ZM234.003 75.8152L238.499 80.9425L242.996 75.8152L238.499 70.6879L234.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 81.7624L234.71 86.0835L238.499 90.4045L242.289 86.0835L238.499 81.7624ZM234.003 86.0835L238.499 91.2107L242.996 86.0835L238.499 80.9562L234.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 61.2361L297.707 65.5572L301.497 69.8782L305.287 65.5572L301.497 61.2361ZM297 65.5572L301.497 70.6845L305.994 65.5572L301.497 60.4299L297 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 71.4941L297.707 75.8152L301.497 80.1362L305.287 75.8152L301.497 71.4941ZM297 75.8152L301.497 80.9425L305.994 75.8152L301.497 70.6879L297 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 81.7624L297.707 86.0835L301.497 90.4045L305.287 86.0835L301.497 81.7624ZM297 86.0835L301.497 91.2107L305.994 86.0835L301.497 80.9562L297 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 61.2361L306.704 65.5572L310.494 69.8782L314.283 65.5572L310.494 61.2361ZM305.997 65.5572L310.494 70.6845L314.991 65.5572L310.494 60.4299L305.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 71.4941L306.704 75.8152L310.494 80.1362L314.283 75.8152L310.494 71.4941ZM305.997 75.8152L310.494 80.9425L314.991 75.8152L310.494 70.6879L305.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 81.7624L306.704 86.0835L310.494 90.4045L314.283 86.0835L310.494 81.7624ZM305.997 86.0835L310.494 91.2107L314.991 86.0835L310.494 80.9562L305.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 61.2361L315.71 65.5572L319.499 69.8782L323.289 65.5572L319.499 61.2361ZM315.003 65.5572L319.499 70.6845L323.996 65.5572L319.499 60.4299L315.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 71.4941L315.71 75.8152L319.499 80.1362L323.289 75.8152L319.499 71.4941ZM315.003 75.8152L319.499 80.9425L323.996 75.8152L319.499 70.6879L315.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 81.7624L315.71 86.0835L319.499 90.4045L323.289 86.0835L319.499 81.7624ZM315.003 86.0835L319.499 91.2107L323.996 86.0835L319.499 80.9562L315.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 92.0212L81.7071 96.3422L85.4969 100.663L89.2866 96.3422L85.4969 92.0212ZM81 96.3422L85.4969 101.47L89.9937 96.3422L85.4969 91.2149L81 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 102.279L81.7071 106.6L85.4969 110.921L89.2866 106.6L85.4969 102.279ZM81 106.6L85.4969 111.727L89.9937 106.6L85.4969 101.473L81 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4969 112.547L81.7071 116.869L85.4969 121.19L89.2866 116.869L85.4969 112.547ZM81 116.869L85.4969 121.996L89.9937 116.869L85.4969 111.741L81 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 92.0212L90.7039 96.3422L94.4936 100.663L98.2834 96.3422L94.4936 92.0212ZM89.9968 96.3422L94.4936 101.47L98.9905 96.3422L94.4936 91.2149L89.9968 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 102.279L90.7039 106.6L94.4936 110.921L98.2834 106.6L94.4936 102.279ZM89.9968 106.6L94.4936 111.727L98.9905 106.6L94.4936 101.473L89.9968 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4936 112.547L90.7039 116.869L94.4936 121.19L98.2834 116.869L94.4936 112.547ZM89.9968 116.869L94.4936 121.996L98.9905 116.869L94.4936 111.741L89.9968 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 92.0212L99.7097 96.3422L103.499 100.663L107.289 96.3422L103.499 92.0212ZM99.0026 96.3422L103.499 101.47L107.996 96.3422L103.499 91.2149L99.0026 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 102.279L99.7097 106.6L103.499 110.921L107.289 106.6L103.499 102.279ZM99.0026 106.6L103.499 111.727L107.996 106.6L103.499 101.473L99.0026 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.499 112.547L99.7097 116.869L103.499 121.19L107.289 116.869L103.499 112.547ZM99.0026 116.869L103.499 121.996L107.996 116.869L103.499 111.741L99.0026 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 92.0212L216.707 96.3422L220.497 100.663L224.287 96.3422L220.497 92.0212ZM216 96.3422L220.497 101.47L224.994 96.3422L220.497 91.2149L216 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 102.279L216.707 106.6L220.497 110.921L224.287 106.6L220.497 102.279ZM216 106.6L220.497 111.727L224.994 106.6L220.497 101.473L216 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.497 112.547L216.707 116.869L220.497 121.19L224.287 116.869L220.497 112.547ZM216 116.869L220.497 121.996L224.994 116.869L220.497 111.741L216 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 92.0212L225.704 96.3422L229.494 100.663L233.283 96.3422L229.494 92.0212ZM224.997 96.3422L229.494 101.47L233.991 96.3422L229.494 91.2149L224.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 102.279L225.704 106.6L229.494 110.921L233.283 106.6L229.494 102.279ZM224.997 106.6L229.494 111.727L233.991 106.6L229.494 101.473L224.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.494 112.547L225.704 116.869L229.494 121.19L233.283 116.869L229.494 112.547ZM224.997 116.869L229.494 121.996L233.991 116.869L229.494 111.741L224.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 92.0212L234.71 96.3422L238.499 100.663L242.289 96.3422L238.499 92.0212ZM234.003 96.3422L238.499 101.47L242.996 96.3422L238.499 91.2149L234.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 102.279L234.71 106.6L238.499 110.921L242.289 106.6L238.499 102.279ZM234.003 106.6L238.499 111.727L242.996 106.6L238.499 101.473L234.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.499 112.547L234.71 116.869L238.499 121.19L242.289 116.869L238.499 112.547ZM234.003 116.869L238.499 121.996L242.996 116.869L238.499 111.741L234.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 92.0212L297.707 96.3422L301.497 100.663L305.287 96.3422L301.497 92.0212ZM297 96.3422L301.497 101.47L305.994 96.3422L301.497 91.2149L297 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 102.279L297.707 106.6L301.497 110.921L305.287 106.6L301.497 102.279ZM297 106.6L301.497 111.727L305.994 106.6L301.497 101.473L297 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.497 112.547L297.707 116.869L301.497 121.19L305.287 116.869L301.497 112.547ZM297 116.869L301.497 121.996L305.994 116.869L301.497 111.741L297 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 92.0212L306.704 96.3422L310.494 100.663L314.283 96.3422L310.494 92.0212ZM305.997 96.3422L310.494 101.47L314.991 96.3422L310.494 91.2149L305.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 102.279L306.704 106.6L310.494 110.921L314.283 106.6L310.494 102.279ZM305.997 106.6L310.494 111.727L314.991 106.6L310.494 101.473L305.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.494 112.547L306.704 116.869L310.494 121.19L314.283 116.869L310.494 112.547ZM305.997 116.869L310.494 121.996L314.991 116.869L310.494 111.741L305.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 92.0212L315.71 96.3422L319.499 100.663L323.289 96.3422L319.499 92.0212ZM315.003 96.3422L319.499 101.47L323.996 96.3422L319.499 91.2149L315.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 102.279L315.71 106.6L319.499 110.921L323.289 106.6L319.499 102.279ZM315.003 106.6L319.499 111.727L323.996 106.6L319.499 101.473L315.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.499 112.547L315.71 116.869L319.499 121.19L323.289 116.869L319.499 112.547ZM315.003 116.869L319.499 121.996L323.996 116.869L319.499 111.741L315.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 0.806234L108.707 5.12728L112.497 9.44832L116.287 5.12728L112.497 0.806234ZM108 5.12728L112.497 10.2546L116.994 5.12728L112.497 -2.34751e-08L108 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 11.0642L108.707 15.3853L112.497 19.7063L116.287 15.3853L112.497 11.0642ZM108 15.3853L112.497 20.5126L116.994 15.3853L112.497 10.258L108 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 21.3325L108.707 25.6536L112.497 29.9746L116.287 25.6536L112.497 21.3325ZM108 25.6536L112.497 30.7808L116.994 25.6536L112.497 20.5263L108 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 0.806234L117.704 5.12728L121.494 9.44832L125.283 5.12728L121.494 0.806234ZM116.997 5.12728L121.494 10.2546L125.991 5.12728L121.494 -2.34751e-08L116.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 11.0642L117.704 15.3853L121.494 19.7063L125.283 15.3853L121.494 11.0642ZM116.997 15.3853L121.494 20.5126L125.991 15.3853L121.494 10.258L116.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 21.3325L117.704 25.6536L121.494 29.9746L125.283 25.6536L121.494 21.3325ZM116.997 25.6536L121.494 30.7808L125.991 25.6536L121.494 20.5263L116.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 0.806234L126.71 5.12728L130.499 9.44832L134.289 5.12728L130.499 0.806234ZM126.003 5.12728L130.499 10.2546L134.996 5.12728L130.499 -2.34751e-08L126.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 11.0642L126.71 15.3853L130.499 19.7063L134.289 15.3853L130.499 11.0642ZM126.003 15.3853L130.499 20.5126L134.996 15.3853L130.499 10.258L126.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 21.3325L126.71 25.6536L130.499 29.9746L134.289 25.6536L130.499 21.3325ZM126.003 25.6536L130.499 30.7808L134.996 25.6536L130.499 20.5263L126.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 0.806234L243.707 5.12728L247.497 9.44832L251.287 5.12728L247.497 0.806234ZM243 5.12728L247.497 10.2546L251.994 5.12728L247.497 -2.34751e-08L243 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 11.0642L243.707 15.3853L247.497 19.7063L251.287 15.3853L247.497 11.0642ZM243 15.3853L247.497 20.5126L251.994 15.3853L247.497 10.258L243 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 21.3325L243.707 25.6536L247.497 29.9746L251.287 25.6536L247.497 21.3325ZM243 25.6536L247.497 30.7808L251.994 25.6536L247.497 20.5263L243 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 0.806234L252.704 5.12728L256.494 9.44832L260.283 5.12728L256.494 0.806234ZM251.997 5.12728L256.494 10.2546L260.991 5.12728L256.494 -2.34751e-08L251.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 11.0642L252.704 15.3853L256.494 19.7063L260.283 15.3853L256.494 11.0642ZM251.997 15.3853L256.494 20.5126L260.991 15.3853L256.494 10.258L251.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 21.3325L252.704 25.6536L256.494 29.9746L260.283 25.6536L256.494 21.3325ZM251.997 25.6536L256.494 30.7808L260.991 25.6536L256.494 20.5263L251.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 0.806234L261.71 5.12728L265.499 9.44832L269.289 5.12728L265.499 0.806234ZM261.003 5.12728L265.499 10.2546L269.996 5.12728L265.499 -2.34751e-08L261.003 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 11.0642L261.71 15.3853L265.499 19.7063L269.289 15.3853L265.499 11.0642ZM261.003 15.3853L265.499 20.5126L269.996 15.3853L265.499 10.258L261.003 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 21.3325L261.71 25.6536L265.499 29.9746L269.289 25.6536L265.499 21.3325ZM261.003 25.6536L265.499 30.7808L269.996 25.6536L265.499 20.5263L261.003 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 0.806234L324.707 5.12728L328.497 9.44832L332.287 5.12728L328.497 0.806234ZM324 5.12728L328.497 10.2546L332.994 5.12728L328.497 -2.34751e-08L324 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 11.0642L324.707 15.3853L328.497 19.7063L332.287 15.3853L328.497 11.0642ZM324 15.3853L328.497 20.5126L332.994 15.3853L328.497 10.258L324 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 21.3325L324.707 25.6536L328.497 29.9746L332.287 25.6536L328.497 21.3325ZM324 25.6536L328.497 30.7808L332.994 25.6536L328.497 20.5263L324 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 0.806234L333.704 5.12728L337.494 9.44832L341.283 5.12728L337.494 0.806234ZM332.997 5.12728L337.494 10.2546L341.991 5.12728L337.494 -2.34751e-08L332.997 5.12728Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 11.0642L333.704 15.3853L337.494 19.7063L341.283 15.3853L337.494 11.0642ZM332.997 15.3853L337.494 20.5126L341.991 15.3853L337.494 10.258L332.997 15.3853Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 21.3325L333.704 25.6536L337.494 29.9746L341.283 25.6536L337.494 21.3325ZM332.997 25.6536L337.494 30.7808L341.991 25.6536L337.494 20.5263L332.997 25.6536Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 31.5913L108.707 35.9123L112.497 40.2334L116.287 35.9123L112.497 31.5913ZM108 35.9123L112.497 41.0396L116.994 35.9123L112.497 30.785L108 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 41.8493L108.707 46.1703L112.497 50.4914L116.287 46.1703L112.497 41.8493ZM108 46.1703L112.497 51.2976L116.994 46.1703L112.497 41.043L108 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 52.1176L108.707 56.4386L112.497 60.7596L116.287 56.4386L112.497 52.1176ZM108 56.4386L112.497 61.5659L116.994 56.4386L112.497 51.3113L108 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 31.5913L117.704 35.9123L121.494 40.2334L125.283 35.9123L121.494 31.5913ZM116.997 35.9123L121.494 41.0396L125.991 35.9123L121.494 30.785L116.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 41.8493L117.704 46.1703L121.494 50.4914L125.283 46.1703L121.494 41.8493ZM116.997 46.1703L121.494 51.2976L125.991 46.1703L121.494 41.043L116.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 52.1176L117.704 56.4386L121.494 60.7596L125.283 56.4386L121.494 52.1176ZM116.997 56.4386L121.494 61.5659L125.991 56.4386L121.494 51.3113L116.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 31.5913L126.71 35.9123L130.499 40.2334L134.289 35.9123L130.499 31.5913ZM126.003 35.9123L130.499 41.0396L134.996 35.9123L130.499 30.785L126.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 41.8493L126.71 46.1703L130.499 50.4914L134.289 46.1703L130.499 41.8493ZM126.003 46.1703L130.499 51.2976L134.996 46.1703L130.499 41.043L126.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 52.1176L126.71 56.4386L130.499 60.7596L134.289 56.4386L130.499 52.1176ZM126.003 56.4386L130.499 61.5659L134.996 56.4386L130.499 51.3113L126.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 31.5913L243.707 35.9123L247.497 40.2334L251.287 35.9123L247.497 31.5913ZM243 35.9123L247.497 41.0396L251.994 35.9123L247.497 30.785L243 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 41.8493L243.707 46.1703L247.497 50.4914L251.287 46.1703L247.497 41.8493ZM243 46.1703L247.497 51.2976L251.994 46.1703L247.497 41.043L243 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 52.1176L243.707 56.4386L247.497 60.7596L251.287 56.4386L247.497 52.1176ZM243 56.4386L247.497 61.5659L251.994 56.4386L247.497 51.3113L243 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 31.5913L252.704 35.9123L256.494 40.2334L260.283 35.9123L256.494 31.5913ZM251.997 35.9123L256.494 41.0396L260.991 35.9123L256.494 30.785L251.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 41.8493L252.704 46.1703L256.494 50.4914L260.283 46.1703L256.494 41.8493ZM251.997 46.1703L256.494 51.2976L260.991 46.1703L256.494 41.043L251.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 52.1176L252.704 56.4386L256.494 60.7596L260.283 56.4386L256.494 52.1176ZM251.997 56.4386L256.494 61.5659L260.991 56.4386L256.494 51.3113L251.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 31.5913L261.71 35.9123L265.499 40.2334L269.289 35.9123L265.499 31.5913ZM261.003 35.9123L265.499 41.0396L269.996 35.9123L265.499 30.785L261.003 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 41.8493L261.71 46.1703L265.499 50.4914L269.289 46.1703L265.499 41.8493ZM261.003 46.1703L265.499 51.2976L269.996 46.1703L265.499 41.043L261.003 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 52.1176L261.71 56.4386L265.499 60.7596L269.289 56.4386L265.499 52.1176ZM261.003 56.4386L265.499 61.5659L269.996 56.4386L265.499 51.3113L261.003 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 31.5913L324.707 35.9123L328.497 40.2334L332.287 35.9123L328.497 31.5913ZM324 35.9123L328.497 41.0396L332.994 35.9123L328.497 30.785L324 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 41.8493L324.707 46.1703L328.497 50.4914L332.287 46.1703L328.497 41.8493ZM324 46.1703L328.497 51.2976L332.994 46.1703L328.497 41.043L324 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 52.1176L324.707 56.4386L328.497 60.7596L332.287 56.4386L328.497 52.1176ZM324 56.4386L328.497 61.5659L332.994 56.4386L328.497 51.3113L324 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 31.5913L333.704 35.9123L337.494 40.2334L341.283 35.9123L337.494 31.5913ZM332.997 35.9123L337.494 41.0396L341.991 35.9123L337.494 30.785L332.997 35.9123Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 41.8493L333.704 46.1703L337.494 50.4914L341.283 46.1703L337.494 41.8493ZM332.997 46.1703L337.494 51.2976L341.991 46.1703L337.494 41.043L332.997 46.1703Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 52.1176L333.704 56.4386L337.494 60.7596L341.283 56.4386L337.494 52.1176ZM332.997 56.4386L337.494 61.5659L341.991 56.4386L337.494 51.3113L332.997 56.4386Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 61.2361L108.707 65.5572L112.497 69.8782L116.287 65.5572L112.497 61.2361ZM108 65.5572L112.497 70.6845L116.994 65.5572L112.497 60.4299L108 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 71.4941L108.707 75.8152L112.497 80.1362L116.287 75.8152L112.497 71.4941ZM108 75.8152L112.497 80.9425L116.994 75.8152L112.497 70.6879L108 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 81.7624L108.707 86.0835L112.497 90.4045L116.287 86.0835L112.497 81.7624ZM108 86.0835L112.497 91.2107L116.994 86.0835L112.497 80.9562L108 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 61.2361L117.704 65.5572L121.494 69.8782L125.283 65.5572L121.494 61.2361ZM116.997 65.5572L121.494 70.6845L125.991 65.5572L121.494 60.4299L116.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 71.4941L117.704 75.8152L121.494 80.1362L125.283 75.8152L121.494 71.4941ZM116.997 75.8152L121.494 80.9425L125.991 75.8152L121.494 70.6879L116.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 81.7624L117.704 86.0835L121.494 90.4045L125.283 86.0835L121.494 81.7624ZM116.997 86.0835L121.494 91.2107L125.991 86.0835L121.494 80.9562L116.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 61.2361L126.71 65.5572L130.499 69.8782L134.289 65.5572L130.499 61.2361ZM126.003 65.5572L130.499 70.6845L134.996 65.5572L130.499 60.4299L126.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 71.4941L126.71 75.8152L130.499 80.1362L134.289 75.8152L130.499 71.4941ZM126.003 75.8152L130.499 80.9425L134.996 75.8152L130.499 70.6879L126.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 81.7624L126.71 86.0835L130.499 90.4045L134.289 86.0835L130.499 81.7624ZM126.003 86.0835L130.499 91.2107L134.996 86.0835L130.499 80.9562L126.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 61.2361L243.707 65.5572L247.497 69.8782L251.287 65.5572L247.497 61.2361ZM243 65.5572L247.497 70.6845L251.994 65.5572L247.497 60.4299L243 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 71.4941L243.707 75.8152L247.497 80.1362L251.287 75.8152L247.497 71.4941ZM243 75.8152L247.497 80.9425L251.994 75.8152L247.497 70.6879L243 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 81.7624L243.707 86.0835L247.497 90.4045L251.287 86.0835L247.497 81.7624ZM243 86.0835L247.497 91.2107L251.994 86.0835L247.497 80.9562L243 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 61.2361L252.704 65.5572L256.494 69.8782L260.283 65.5572L256.494 61.2361ZM251.997 65.5572L256.494 70.6845L260.991 65.5572L256.494 60.4299L251.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 71.4941L252.704 75.8152L256.494 80.1362L260.283 75.8152L256.494 71.4941ZM251.997 75.8152L256.494 80.9425L260.991 75.8152L256.494 70.6879L251.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 81.7624L252.704 86.0835L256.494 90.4045L260.283 86.0835L256.494 81.7624ZM251.997 86.0835L256.494 91.2107L260.991 86.0835L256.494 80.9562L251.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 61.2361L261.71 65.5572L265.499 69.8782L269.289 65.5572L265.499 61.2361ZM261.003 65.5572L265.499 70.6845L269.996 65.5572L265.499 60.4299L261.003 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 71.4941L261.71 75.8152L265.499 80.1362L269.289 75.8152L265.499 71.4941ZM261.003 75.8152L265.499 80.9425L269.996 75.8152L265.499 70.6879L261.003 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 81.7624L261.71 86.0835L265.499 90.4045L269.289 86.0835L265.499 81.7624ZM261.003 86.0835L265.499 91.2107L269.996 86.0835L265.499 80.9562L261.003 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 61.2361L324.707 65.5572L328.497 69.8782L332.287 65.5572L328.497 61.2361ZM324 65.5572L328.497 70.6845L332.994 65.5572L328.497 60.4299L324 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 71.4941L324.707 75.8152L328.497 80.1362L332.287 75.8152L328.497 71.4941ZM324 75.8152L328.497 80.9425L332.994 75.8152L328.497 70.6879L324 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 81.7624L324.707 86.0835L328.497 90.4045L332.287 86.0835L328.497 81.7624ZM324 86.0835L328.497 91.2107L332.994 86.0835L328.497 80.9562L324 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 61.2361L333.704 65.5572L337.494 69.8782L341.283 65.5572L337.494 61.2361ZM332.997 65.5572L337.494 70.6845L341.991 65.5572L337.494 60.4299L332.997 65.5572Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 71.4941L333.704 75.8152L337.494 80.1362L341.283 75.8152L337.494 71.4941ZM332.997 75.8152L337.494 80.9425L341.991 75.8152L337.494 70.6879L332.997 75.8152Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 81.7624L333.704 86.0835L337.494 90.4045L341.283 86.0835L337.494 81.7624ZM332.997 86.0835L337.494 91.2107L341.991 86.0835L337.494 80.9562L332.997 86.0835Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 92.0212L108.707 96.3422L112.497 100.663L116.287 96.3422L112.497 92.0212ZM108 96.3422L112.497 101.47L116.994 96.3422L112.497 91.2149L108 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 102.279L108.707 106.6L112.497 110.921L116.287 106.6L112.497 102.279ZM108 106.6L112.497 111.727L116.994 106.6L112.497 101.473L108 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.497 112.547L108.707 116.869L112.497 121.19L116.287 116.869L112.497 112.547ZM108 116.869L112.497 121.996L116.994 116.869L112.497 111.741L108 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 92.0212L117.704 96.3422L121.494 100.663L125.283 96.3422L121.494 92.0212ZM116.997 96.3422L121.494 101.47L125.991 96.3422L121.494 91.2149L116.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 102.279L117.704 106.6L121.494 110.921L125.283 106.6L121.494 102.279ZM116.997 106.6L121.494 111.727L125.991 106.6L121.494 101.473L116.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.494 112.547L117.704 116.869L121.494 121.19L125.283 116.869L121.494 112.547ZM116.997 116.869L121.494 121.996L125.991 116.869L121.494 111.741L116.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 92.0212L126.71 96.3422L130.499 100.663L134.289 96.3422L130.499 92.0212ZM126.003 96.3422L130.499 101.47L134.996 96.3422L130.499 91.2149L126.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 102.279L126.71 106.6L130.499 110.921L134.289 106.6L130.499 102.279ZM126.003 106.6L130.499 111.727L134.996 106.6L130.499 101.473L126.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.499 112.547L126.71 116.869L130.499 121.19L134.289 116.869L130.499 112.547ZM126.003 116.869L130.499 121.996L134.996 116.869L130.499 111.741L126.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 92.0212L243.707 96.3422L247.497 100.663L251.287 96.3422L247.497 92.0212ZM243 96.3422L247.497 101.47L251.994 96.3422L247.497 91.2149L243 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 102.279L243.707 106.6L247.497 110.921L251.287 106.6L247.497 102.279ZM243 106.6L247.497 111.727L251.994 106.6L247.497 101.473L243 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.497 112.547L243.707 116.869L247.497 121.19L251.287 116.869L247.497 112.547ZM243 116.869L247.497 121.996L251.994 116.869L247.497 111.741L243 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 92.0212L252.704 96.3422L256.494 100.663L260.283 96.3422L256.494 92.0212ZM251.997 96.3422L256.494 101.47L260.991 96.3422L256.494 91.2149L251.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 102.279L252.704 106.6L256.494 110.921L260.283 106.6L256.494 102.279ZM251.997 106.6L256.494 111.727L260.991 106.6L256.494 101.473L251.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.494 112.547L252.704 116.869L256.494 121.19L260.283 116.869L256.494 112.547ZM251.997 116.869L256.494 121.996L260.991 116.869L256.494 111.741L251.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 92.0212L261.71 96.3422L265.499 100.663L269.289 96.3422L265.499 92.0212ZM261.003 96.3422L265.499 101.47L269.996 96.3422L265.499 91.2149L261.003 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 102.279L261.71 106.6L265.499 110.921L269.289 106.6L265.499 102.279ZM261.003 106.6L265.499 111.727L269.996 106.6L265.499 101.473L261.003 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.499 112.547L261.71 116.869L265.499 121.19L269.289 116.869L265.499 112.547ZM261.003 116.869L265.499 121.996L269.996 116.869L265.499 111.741L261.003 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 92.0212L324.707 96.3422L328.497 100.663L332.287 96.3422L328.497 92.0212ZM324 96.3422L328.497 101.47L332.994 96.3422L328.497 91.2149L324 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 102.279L324.707 106.6L328.497 110.921L332.287 106.6L328.497 102.279ZM324 106.6L328.497 111.727L332.994 106.6L328.497 101.473L324 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.497 112.547L324.707 116.869L328.497 121.19L332.287 116.869L328.497 112.547ZM324 116.869L328.497 121.996L332.994 116.869L328.497 111.741L324 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 92.0212L333.704 96.3422L337.494 100.663L341.283 96.3422L337.494 92.0212ZM332.997 96.3422L337.494 101.47L341.991 96.3422L337.494 91.2149L332.997 96.3422Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 102.279L333.704 106.6L337.494 110.921L341.283 106.6L337.494 102.279ZM332.997 106.6L337.494 111.727L341.991 106.6L337.494 101.473L332.997 106.6Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.494 112.547L333.704 116.869L337.494 121.19L341.283 116.869L337.494 112.547ZM332.997 116.869L337.494 121.996L341.991 116.869L337.494 111.741L332.997 116.869Z",
    fill: "white",
    fillOpacity: 0.07
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_1755",
    x1: 168.5,
    y1: 0,
    x2: 168.5,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B629D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111F3E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.12bfd1eca7cb979dd3731f6933ed39ec.svg";
export { ForwardRef as ReactComponent };